import React from 'react'
import BlueButton from 'components/inputs/BlueButton'
import MySpinner from 'components/MySpinner'
import { ICartOrder } from 'order_components/IOrder'
import { PAGE_URL_CART } from 'SiteURLs'
import { useCart } from 'cart/CartProvider'

const getProductCount = (order: ICartOrder) => {
  let count = 0
  order.products.forEach((prod) => {
    count += prod.quantity
  })
  return count
}

const getProperEnding = (order: ICartOrder) => {
  const count = getProductCount(order)
  let val = count % 100

  if (val > 10 && val < 20) {
    return count + ' товаров'
  } else {
    val = count % 10
    if (val === 1) {
      return count + ' товар'
    } else if (val > 1 && val < 5) {
      return count + ' товара'
    } else {
      return count + ' товаров'
    }
  }
}

const getProductSum = (order: ICartOrder) => {
  let sum = 0
  order.products.forEach((prod) => {
    sum += prod.quantity * prod.price
  })
  return sum
}

interface ICartTotalPanelProps {}

const CartTotalPanel: React.FC<ICartTotalPanelProps> = () => {
  const [cart] = useCart()
  // const cart = useRecoilValue(cartOrderRecoilState)

  return (
    <div className='py-dynamic-mini price-panel'>
      {cart ? (
        <>
          {cart.products.length > 0 ? (
            <>
              <div className='sm-height-col-disp justify-content-around'>
                <div>
                  <h5>В корзине</h5>
                  <h6>{getProperEnding(cart)}</h6>
                </div>
                <h5>На сумму {getProductSum(cart)} ₽</h5>
                <BlueButton
                  className='mt-1'
                  href={'#/' + PAGE_URL_CART}
                  style={{ height: 'fit-content' }}
                >
                  Оформить
                </BlueButton>
              </div>
            </>
          ) : (
            <>
              <h5>В корзине</h5>
              <h6>Нет товаров</h6>
            </>
          )}
        </>
      ) : (
        <MySpinner />
      )}
    </div>
  )
}
export default CartTotalPanel
